import type { FallbackRender } from "@sentry/react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

function handleReload(): void {
  window.location.reload();
}

export const sentryErrorFallbackRender: FallbackRender = ({
  resetError,
}) => (
  <div className="flex min-h-screen items-center justify-center bg-background p-4">
    <Card className="w-full max-w-md border-border">
      <CardHeader className="flex flex-row items-center gap-2 space-y-0">
        <AlertTriangle className="h-5 w-5 text-warning" aria-hidden />
        <CardTitle className="text-lg font-semibold">
          Something went wrong
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          The application hit an unexpected error. You can try again or reload
          the page.
        </p>
      </CardContent>
      <CardFooter className="flex flex-wrap gap-2">
        <Button type="button" onClick={() => resetError()}>
          Try again
        </Button>
        <Button type="button" variant="secondary" onClick={handleReload}>
          Reload
        </Button>
      </CardFooter>
    </Card>
  </div>
);
